import { makeRef } from "@/components/composables/reactivityTypes";
import { setVuetifyTheme } from "@/plugins/vuetify";

const darkState = makeRef(false);
const localStorageThemeKey = "app-theme";

function setMode(dark: boolean) {
  darkState.value = dark;
  setVuetifyTheme(dark);
  const themeName = dark ? "dark" : "light";
  document.querySelector("html")?.setAttribute("data-theme", themeName);
  localStorage.setItem(localStorageThemeKey, themeName);
}

function setModeFromLocalStorage() {
  const themeName = localStorage.getItem(localStorageThemeKey);
  setMode(themeName === "dark");
}

export const theme = {
  setMode,
  setModeFromLocalStorage,
  isDark: () => darkState.value,
};
